import { supabase } from "@/integrations/supabase/client";

export const fetchBusinessInfo = async (userId: string) => {
  try {
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('business_name, street_address, city, state, zip_code')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Failed to fetch business info:', error);
      return null;
    }

    const businessAddress = [profile?.street_address, profile?.city, profile?.state, profile?.zip_code]
      .filter(Boolean)
      .join(', ');

    return {
      business_name: profile?.business_name || null,
      business_address: businessAddress || null,
      street_address: profile?.street_address || null,
      city: profile?.city || null,
      state: profile?.state || null,
      zip_code: profile?.zip_code || null
    };
  } catch (error) {
    console.error('Error fetching business info:', error);
    return null;
  }
};
